import VspinInstrumentPage from './VspinInstrumentPage'

export default VspinInstrumentPage
